module.exports = __webpack_public_path__ + "static/media/bulk_master_transporter.6f7bbc75.csv";